/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { dropTask } from 'ember-concurrency';
import RouterService from '@ember/routing/router-service';
import DS from 'ember-data';
import AuthService from 'cio/services/auth';
import AnalyticsService from 'cio/services/analytics';
import SubscriptionCenterService from 'cio/services/subscription-center';
import AccountService from 'cio/services/account';
import EnvironmentService from 'cio/services/environment';
import { getTrackApiHostForDataCenter } from 'cio/utils/data-centers';
import FeaturesService from 'ember-feature-flags/services/features';

export default class SubscriptionHeader extends Component<never> {
  @service account!: AccountService;
  @service analytics!: AnalyticsService;
  @service auth!: AuthService;
  @service environment!: EnvironmentService;
  @service subscriptionCenter!: SubscriptionCenterService;
  @service store!: DS.Store;
  @service route!: RouterService;
  @service features!: FeaturesService;

  constructor(owner: unknown, args: never) {
    super(owner, args);

    this.initializeData.perform();
  }

  get brandingDisabled() {
    if (!this.subscriptionCenter.initialized) {
      return true;
    }

    return this.subscriptionCenter.hasNoTopics;
  }

  @action
  trackExampleLink() {
    this.analytics.track('subscription_center', 'example_clicked');
  }

  @action
  trackPreviewLink() {
    this.analytics.track('subscription_center', 'preview_clicked');
  }

  initializeData = dropTask(async () => {
    await this.subscriptionCenter.initializeTask.perform(true);
  });

  get trackAPIManageSubPreferencesPreviewURL() {
    let payload = { envId: parseInt(this.environment.current.id ?? '0'), uuid: window.UUID.generate() };
    let token = btoa(JSON.stringify(payload));

    let uri = this.subscriptionCenter.enabled ? 'manage_subscription_preferences' : 'unsubscribe';
    let url = new URL(uri, getTrackApiHostForDataCenter(this.account.current?.dataCenter));
    url.searchParams.append('token', token);

    return url.toString();
  }
}
